// Generic, app-wide UI strings (button labels, common success messages) that are not tied to a
// single domain. Keys migrated here from the deprecated frontend/i18n/en-us/messages.js as the
// global locale structure is consolidated under frontend/locales/.

export default {
    'label.abort_button': 'Never mind',

    'message.success.file_downloaded': 'File has been successfully downloaded.',
};
